export default class LayerMenuPanel {
  get CLASSNAMES() {
    return {
      show: 'show-panel',
    };
  }
  constructor(panelElement) {
    this.isActive = false;
    this.panelElement = panelElement;
    this.panelTitle = this.panelElement.querySelector('[data-panel-title]');
    this.backBtn = this.panelElement.querySelector('[data-close-panel]');
    this.leaveHandler = () => '';
    this.backHandler = () => '';
  }
  onLeave(callback) {
    let mq = window.matchMedia('(min-width:992px)');
    if (!mq.matches) {
      return;
    }
    this.leaveHandler = callback;
    this.panelElement.addEventListener('mouseleave', this.leaveHandler);
  }
  whenBack(callback) {
    this.backHandler = callback;
    this.backBtn.addEventListener('click', this.backHandler);
  }
  showLayer() {
    this.panelElement.classList.add(this.CLASSNAMES.show);
    this.isActive = true;
  }
  hideLayer() {
    this.panelElement.classList.remove(this.CLASSNAMES.show);
    this.panelElement.removeEventListener('mouseleave', this.leaveHandler);
    this.backBtn.removeEventListener('click', this.backHandler);
    this.isActive = false;
  }
  setTitle(text) {
    if (!this.panelTitle) {
      return;
    }
    this.panelTitle.innerText = text;
  }
  checkChild(element) {
    return this.panelElement.contains(element);
  }
}
